import * as React from "react"
import * as ReactDom from "react-dom"
import Session from "../components/views/Session";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
    const sessionsContainer = document.getElementById('session')
	ReactDom.render(<Session />, sessionsContainer)
    setCurrentPage('session')
}